import axios from "axios";

const _URLS = {
  development: "https://m.cs.com.cn",
  testing: "http://123.60.153.169:8081",
  pre: "http://123.60.153.169:8081",
  // production: "https://wp2botvx.cs.com.cn",
  production: "https://m.cs.com.cn",
};

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: _URLS[process.env.NODE_ENV],
  // 超时
  timeout: 20000,
});

//添加一个请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加一个响应拦截器
service.interceptors.response.use(
  (res) => {
    return res.data;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export const GET = async (url, params) => {
  let response = {};

  try {
    response = await service({
      url: url,
      method: "get",
      params,
    });
  } catch (err) {
    response = err;
  }

  return response;
};

// export default service;
